/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Container, Modal } from '@landing_academy/shared/@mantine/core';
import '@mantine/core/styles.css';

import FormContattoShared from '@landing_academy/shared/components-mantine/FormContatto';
import AnalyticsAndGdprShared from '@landing_academy/shared/components-mantine/AnalyticsAndGdpr';

import Header from './Header';
import Footer from './Footer';
import Seo from './seo';
import { useSiteMetadata } from '../hooks/metadata';
import { useLandingData } from '../hooks/homePage';
import { theme, Layout as LayoutShared, AppContext } from './provider';


function Layout({
  pageContext: { seoFields:seo, titoloPagina: titolo, formContattiOverride, stub },
  children, location,
}) {
  const siteMetadata = useSiteMetadata();
  const landingData = useLandingData();
  const formContattoData = formContattiOverride || landingData.formContatti;

  return (
    <LayoutShared
      titolo={titolo}
      seo={seo}
      location={location}
      siteMetadata={siteMetadata}
      landingData={landingData}
    >
      <AppContext.Consumer>
        {({ state, setter }) => (
          <div>
            <div>
              <Seo
                title={seo?.seoTitle || titolo}
                description={seo?.seoDescription}
                stub={stub}
              />
              <Header location={location} />
              <Container m={0} pr={0} pl={0} fluid>{children}</Container>
              <Footer />
            </div>
            <AnalyticsAndGdprShared
              setGDPRChoicesFunction={(options) => setter({
                userSettings: { ...state.userSettings, ...options },
              })}
              userSettings={state.userSettings}
              locationPathname={location?.pathname}
              pageTitle={titolo}
            />
            <Modal
              title={formContattoData.formContattiTitleModal}
              closeButtonProps={{ 'aria-label': 'Chiudi' }}
              radius="md"
              opened={state.formContattoOpened}
              onClose={() => setter({ formContattoOpened: false })}
              centered
              size="xl"
            >
              <FormContattoShared
                formContattoData={{ ...formContattoData, stub, modalDisplay: true }} />
            </Modal>
          </div>
        )}
      </AppContext.Consumer>
    </LayoutShared>
  );
}

export { AppContext, theme };
export default Layout;

Layout.propTypes = {
  titolo: PropTypes.string,
  seo: PropTypes.shape({
    seoTitle: PropTypes.string,
    seoDescription: PropTypes.string
  }),
  children: PropTypes.node.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    hash: PropTypes.string,
  }),
};
